import { Stack } from "expo-router";

export default function CancelLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="offer" />
      <Stack.Screen name="claims" />
      <Stack.Screen name="final" />
      <Stack.Screen name="success" />
    </Stack>
  );
}
